import React from 'react';
import {
  navigationMenu,
  footerInfo
} from '../data/conclaveData';

import * as LucideIcons from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import { markdownConfig } from '../utils/markdownUtils';

const XIcon = () => (


  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    className="fill-current text-white hover:text-pink-400 transition"
    viewBox="0 0 24 24"
  >

    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
  </svg>

);


const WAIcon = () => (

  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    className="fill-current text-white hover:text-pink-400 transition"
    viewBox="0 0 24 24"
  >
    <g transform="scale(1.3) translate(2, 2)">
      <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" ></path>
    </g>
  </svg>
)


export default function Footer() {
  const quickLinks = navigationMenu
    .filter((item) => item.display && !item.isRoute)
    .sort((a, b) => a.order - b.order)
    .slice(0, 6);

  // const eventDate =
  //   EventMetaitems.find((item) => item.label.includes('October'))?.label ||
  //   'January 21, 2026';
  // const eventVenue =
  //   EventMetaitems.find((item) => item.label.includes('Auditorium'))?.label ||
  //   'JN Tata Auditorium, Bangalore';
  // const expectedDelegates =
  //   EventMetaitems.find((item) => item.label.includes('Delegates'))?.label ||
  //   '2500+ Delegates';

  return (
    <footer className="bg-[#0C091C] text-white pt-20 pb-10 border-t border-white/10">
      <div className="max-w-[1728px] w-full mx-auto px-5 md:px-24">
        {/* Footer Grid with 4 Columns */}
        <div className="grid md:grid-cols-12 gap-8 text-sm">
          {/* 1. Event Secretariat */}
          <div className="md:col-span-3">
            <h4 className="text-lg font-bold text-pink-400 mb-4 uppercase">
              {footerInfo.eventSecretariat.heading}
            </h4>
            <p className="font-semibold mb-1">{footerInfo.eventSecretariat.organization}</p>
            {footerInfo.eventSecretariat.address.map((line, idx) => (
              <p key={idx}>{line}</p>
            ))}
            <p className="mt-2">{footerInfo.eventSecretariat.phone}</p>
          </div>

          {/* 2. Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-lg font-bold text-pink-400 mb-4 uppercase">Quick Links</h4>
            <div className="flex gap-8">
              <ul className="space-y-2">
                {quickLinks.slice(0, Math.ceil(quickLinks.length / 2)).map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        const el = document.getElementById(link.id);
                        if (el) el.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-white/80 hover:text-white transition-all"
                    >
                      • {link.label}
                    </a>
                  </li>
                ))}
              </ul>
              <ul className="space-y-2">
                {quickLinks.slice(Math.ceil(quickLinks.length / 2)).map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        const el = document.getElementById(link.id);
                        if (el) el.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-white/80 hover:text-white transition-all"
                    >
                      • {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* 3. Follow Us */}
          <div className="md:col-span-3">
            <h4 className="text-lg font-bold text-pink-400 mb-4 uppercase">
              {footerInfo.followUs.heading}
            </h4>
            <p className="text-white/70 mb-4">{footerInfo.followUs.description}</p>
            <div className="flex flex-wrap items-center gap-3 text-white">
              {footerInfo.followUs.socialLinks.map((social) => {

                let IconComponent;

                if (social.icon === 'XIcon') {
                  IconComponent = XIcon;
                } else if (social.icon === 'WAIcon') {
                  IconComponent = WAIcon;
                } else {
                  IconComponent = LucideIcons[social.icon] || LucideIcons.Globe;
                }

                // const Icon = LucideIcons[social.icon] || LucideIcons.Globe;
                return (
                  <a key={social.name} href={social.url} aria-label={social.name} target="_blank" rel="noopener noreferrer">
                    <IconComponent className="w-5 h-5 hover:text-pink-400 transition" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* 4. Contact Us */}
          <div className="md:col-span-3">
            <h4 className="text-lg font-bold text-pink-400 mb-4 uppercase">
              {footerInfo.contactUs.heading}
            </h4>
            <p className="mb-2">
              <span className="text-white/50">Email:</span>{' '}
              <a
                href={`mailto:${footerInfo.contactUs.email}`}
                className="text-white/80 hover:text-white"
              >
                {footerInfo.contactUs.email}
              </a>
            </p>
            <p className="mb-2">
              <span className="text-darkbg">Email:</span>{' '}
              <a
                href={`mailto:${footerInfo.contactUs.email1}`}
                className="text-white/80 hover:text-white"
              >
                {footerInfo.contactUs.email1}
              </a>
            </p>
            <p>
              <span className="text-white/50">Phone:</span>{' '}
              <a
                href={`tel:${footerInfo.contactUs.phone.replace(/\s+/g, '')}`}
                className="text-white/80 hover:text-white"
              >
                {footerInfo.contactUs.phone}
              </a>
            </p>
          </div>
        </div>

        {/* SKILLABLERS Block aligned with above */}
        <div className="mt-10 text-sm">
          <h4 className="text-lg font-bold text-pink-400 font-semibold mb-2">
            {footerInfo.aboutSKL.heading}
          </h4>

          <div className="prose prose-invert text-white/90 max-w-none text-justify">
            <ReactMarkdown {...markdownConfig}>
              {footerInfo.aboutSKL.mainDescription}
            </ReactMarkdown>
          </div>

          <div className="prose prose-invert text-white/90 max-w-none mt-4 text-justify">
            <ReactMarkdown {...markdownConfig}>
              {footerInfo.aboutSKL.description}
            </ReactMarkdown>
          </div>
        </div>

        {/* Bottom Note */}
        <div className="pt-10 mt-12 border-t border-white/10 text-xs text-white/50 text-center">
          {footerInfo.bottomNote || `© ${new Date().getFullYear()} Strategic TechTrust Conclave. Hosted by CSI Bangalore • Curated & Powered by SKILLABLERS`}
        </div>
      </div>
    </footer>
  );
}
